module.exports = __webpack_public_path__ + "static/media/cp403.fe5ad6b8.png";